import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import 'normalize.css';
import Head from 'next/head';
// import { PersistGate } from 'redux-persist/integration/react';
import { Provider, useStore } from 'react-redux';

import TagManager from 'react-gtm-module';
//* Redux Store
import { wrapper } from '../redux/store';
//* Style
import '../styles/global.scss';
import '../styles/fonts.scss';
import '../styles/icon.scss';
import '../styles/form.scss';

const MyApp = ({ Component, pageProps }) => {
    const store = useStore(state => state);

    const router = useRouter();

    useEffect(() => {
        if (process.env.GTM_ID) {
            TagManager.initialize({ gtmId: process.env.GTM_ID });
        }
    }, []);

    useEffect(() => {
        if (router.asPath.startsWith('/news-and-insights')) {
            document.body.classList.add('_is-news-insights');
        } else {
            document.body.classList.remove('_is-news-insights');
        }
    }, [router.asPath]);

    // Get isPreviewDomain from pageProps (set in getInitialProps)
    const isPreviewDomain = pageProps?.isPreviewDomain || false;

    return (
        <Provider store={store}>
            {/* <PersistGate loading={null} persistor={store.__persistor}> */}
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1.0, maximum-scale=1' />
                {isPreviewDomain && (
                    <meta name='robots' content='noindex, nofollow' />
                )}
            </Head>
            <Component {...pageProps} />
            {/* </PersistGate> */}
        </Provider>
    );
};

MyApp.getInitialProps = async ({ Component, ctx }) => {
    const { res, req } = ctx;
    const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};

    // Check if current domain is a preview domain (server-side)
    const hostname = req?.headers?.host || '';
    const previewDomains = ['preview.permira.com', 'preview.permira.cn'];
    const isPreviewDomain = previewDomains.some(domain => hostname.includes(domain));

    if (res) {
        try {
            res.setHeader('Cache-Control', 's-maxage=86400, stale-while-revalidate');
        } catch (e) {

        }
    }

    return { pageProps: { ...pageProps, isPreviewDomain } };
};

MyApp.propTypes = {
    Component: PropTypes.func,
    pageProps: PropTypes.object,
};

MyApp.defaultProps = {};

// withRedux wrapper that passes the store to the App Component
export default wrapper.withRedux(MyApp);
